import React from 'react';
import { MdClose } from 'react-icons/md';
import MuiAlert from '@mui/material/Alert';
import { Col, Modal, Row } from 'react-bootstrap';
import { ReactComponent as DropdownIcon } from 'src/Images/icons/common/dropdown.svg';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';
import getColorCode from 'src/utils/GetThemeColor';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';

export default function TargetVsActualFormMobile({
  selectedTargetVsActualConfig,
  toggleTargetVsActualForm,
  logic,
}) {
  const {
    targetVsActualData,
    themeColor,
    captureWeightButtonAnimation,
    handleCaptureWeight,
    handleSubmit,
    invalidFormSubmission,
    setInvalidFormSubmission,
    // Modal related state and functions
    showWeightBridgeModal,
    setSelectedWeightBridge,
    selectedWeightBridge,
    weighBridgeWorkCenters,
    handleWeightBridgeSelectionSubmit,
    handleCloseModal,
    tareWeightHistoryForVehicleNumber,
    isTareWeightCapture,
  } = logic;
  const renderCards = () =>
    (targetVsActualData || []).map((item) => (
      <div
        key={item.id}
        className="main-vehicle-tracking-detail-form-component mb-3"
      >
        <div className="form-line-item-container top-padding">
          <div className="text-md">
            <span className="text-bold">ID: </span>
            <span className="left-padding  text-semi-bold text-grey">
              {item.id}
            </span>
          </div>
          <div className="text-md text-bold">
            <span className="text-bold">Name: </span>
            <span className="left-padding  text-semi-bold text-grey">
              {item.name}
            </span>
          </div>

          {selectedTargetVsActualConfig?.is_weight ? (
            <div className="d-flex justify-content-end">
              {captureWeightButtonAnimation ? (
                <div className="div-flex-row cg-5 div-align-center">
                  <span className="text-sm text-bold">Capturing Weight</span>
                  <div className="capture-weight-animation">
                    <span className="capture-weight-loading-dot"></span>
                    <span className="capture-weight-loading-dot"></span>
                    <span className="capture-weight-loading-dot"></span>
                  </div>
                </div>
              ) : (
                <button
                  className={`vehicle-tracking-detail-add-vehcile-data-btn theme-text-${themeColor} theme-border-color-${themeColor} div-align-center`}
                  onClick={handleCaptureWeight}
                >
                  <span className="text-md text-semi-bold p-1">
                    Capture Weight
                  </span>
                </button>
              )}
            </div>
          ) : null}

          <div className="d-flex flex-column flex-fill right-padding rg-5">
            <div className="text-md text-bold">Target Value</div>
            <input
              name={`target_${item.id}`}
              type="text"
              className="form-input-section"
              value={item.target_value}
              disabled={selectedTargetVsActualConfig?.is_weight}
            />
          </div>
          <div className="d-flex flex-column flex-fill right-padding rg-5">
            <div className="text-md text-bold">Actual Value</div>
            <input
              name={`actual_${item.id}`}
              type="text"
              className="form-input-section"
              defaultValue={item.actual_value}
              disabled={selectedTargetVsActualConfig?.is_weight}
            />
          </div>
          <div className="d-flex flex-column flex-fill right-padding rg-5">
            <div className="text-md text-bold">Remark</div>
            <input
              name={`remark_${item.id}`}
              type="text"
              className="form-input-section"
              defaultValue={item.remarks}
            />
          </div>
        </div>
      </div>
    ));

  const renderTareWeightHistory = () => {
    if (!isTareWeightCapture) return null;

    return (
      <div className="target-vs-actual-history-section">
        <span className="target-vs-actual-history-pill">Tare Weight Log</span>
        <div className="target-vs-actual-history-timeline">
          {tareWeightHistoryForVehicleNumber?.length ? (
            tareWeightHistoryForVehicleNumber.map((item) => (
              <div
                className="target-vs-actual-history-item"
                key={item.vehicle_tracking_number}
              >
                <div className="div-flex-row div-space-between div-align-center">
                  <span className="text-md text-bold">
                    {item.created_date || '-'}
                  </span>
                  <span className="text-md text-grey">
                    {item.created_time || '-'}
                  </span>
                </div>
                <div className="target-vs-actual-history-card">
                  <div className="target-vs-actual-history-card-cell">
                    <span className="text-sm text-bold">Vehicle Code</span>
                    <span className="text-md text-grey">
                      {item.vehicle_tracking_code || '-'}
                    </span>
                  </div>
                  <div className="target-vs-actual-history-card-cell">
                    <span className="text-sm text-bold">Weight</span>
                    <span className="text-md text-grey">
                      {item.tare_weight_actual_value
                        ? `${item.tare_weight_actual_value} kg`
                        : '-'}
                    </span>
                  </div>
                  <div className="target-vs-actual-history-card-cell">
                    <span className="text-sm text-bold">Remark</span>
                    <span className="text-md text-grey">
                      {item.tare_weight_remarks || '-'}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="target-vs-actual-history-empty">
              No tare weight log found
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="page-layout gap-2">
      <div className="div-flex-row div-space-between div-align-center border-bottom drawer-section-padding">
        <div className="div-space-between slider-padding">
          <span className="text-xxl text-bold">
            {selectedTargetVsActualConfig?.title}
          </span>
        </div>
        <button
          className="icon-btn-none"
          onClick={() => toggleTargetVsActualForm({})}
          aria-label="Close drawer"
        >
          <MdClose size="24px" />
        </button>
      </div>

      {invalidFormSubmission && (
        <MuiAlert
          onClose={() => setInvalidFormSubmission(false)}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Please enter all Actual values or capture weight before submitting.
        </MuiAlert>
      )}

      <div className="drawer-section-padding">
        <div className="line-item-container-padding">
          <div className="main-vehicle-tracking-detail-form-component mb-2">
            <div className="d-flex align-items-center  justify-space-between timeline-header mb-2">
              <div className="text-lg text-bold">Assignment Information</div>
              <button
                type="button"
                className={`vehicle-data-form-submit-btn theme-background-${themeColor}`}
                onClick={(e) => handleSubmit(e)}
              >
                <span className="text-md">Submit</span>
              </button>
            </div>
            <div className="form-line-item-container">
              <div className="text-md ">
                <span className="text-bold">Assigned Table: </span>
                <span className="left-padding text-semi-bold text-grey">
                  {selectedTargetVsActualConfig?.table_name}
                </span>
              </div>

              <div className="text-md">
                <span className="text-bold">Assigned Field: </span>
                <span className="left-padding  text-semi-bold text-grey">
                  {selectedTargetVsActualConfig?.field_name}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`main-vehicle-tracking-detail-container-mobile theme-scrollable-container-${themeColor}`}
        >
          {renderCards()}
          {renderTareWeightHistory()}
        </div>
      </div>

      <Modal
        show={showWeightBridgeModal}
        onHide={handleCloseModal}
        centered
        size="md"
        dialogClassName="custom-modal"
      >
        <Modal.Body>
          <div className="div-flex-column rg-20">
            <Row>
              <Col xl={11} lg={11} md={11} sm={11} xs={11}>
                <div className="div-flex-row cg-10 div-space-between">
                  <span className="text-xl text-nowrap">
                    Select Weight Bridge
                  </span>
                </div>
              </Col>

              <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                <div className="div-flex-row div-flex-end">
                  <Close
                    className="icon-size-sm cursor-pointer"
                    color="#ccc"
                    onClick={handleCloseModal}
                  />
                </div>
              </Col>
            </Row>

            <div className="div-flex-column rg-20">
              <div className="input-wrapper">
                <CustomMultiSelect
                  isMulti={false}
                  options={weighBridgeWorkCenters?.map((option) => ({
                    value: option.id,
                    label: option.name,
                    ...option,
                  }))}
                  value={selectedWeightBridge}
                  onChange={(selectedOption) =>
                    setSelectedWeightBridge(selectedOption)
                  }
                  placeholder="Select a weight bridge..."
                  isSearchable
                  className="multi-select-input-section"
                  classNamePrefix="react-select"
                />
                <span className="form-input-section-icon">
                  <DropdownIcon
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
              <div className="div-flex-row div-space-between">
                <button
                  className={`d-flex vehicle-tracking-detail-add-vehcile-data-btn theme-text-${themeColor} theme-border-color-${themeColor} div-align-center`}
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  className={`d-flex vehicle-tracking-detail-move-stage-btn theme-background-${themeColor}`}
                  onClick={() => handleWeightBridgeSelectionSubmit()}
                >
                  Capture Weight
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
